var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn btn-danger pull-right mb-10",attrs:{"title":this.$root.trans.back,"to":{name: _vm.routeName}}},[_c('i',{staticClass:"ti-close"})])
}
var staticRenderFns = []

export { render, staticRenderFns }